// Build a Google Maps link for a location (object {name,address} or string).
// Prefers the full address; falls back to the branch name.
export default function mapsUrl(loc) {
  const isObj = typeof loc === 'object' && loc !== null;
  const query = (isObj ? (loc.address || loc.name) : loc) || '';
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}
